module.exports = __webpack_public_path__ + "img/GB-NIR.d8cf1ae6.svg";